import * as type from '../actions/types';

const initialState = {
    profileEdit: [],
    loading: false,
    error: null,
}

export default function getProfileEditData(state = initialState, action) {
    switch (action.type) {
        case type.GET_PROFILE_EDIT_DATA_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_PROFILE_EDIT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                profileEdit: action.data,
                // error:action.errors
            }
        case type.GET_PROFILE_EDIT_DATA_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}